export function formatFqnForSnowflake(fqn: string) {
  return fqn
    .split('.')
    .map((part) => {
      if (!part.startsWith('"') || !part.endsWith('"')) {
        // Snowflake assumes uppercase for unquoted identifiers
        return `"${part.toUpperCase()}"`
      }
      return part
    })
    .join('.')
}
